import { createNavigationView } from './index'
import { VIEW_ADVERTISER, VIEW_EMPLOYER } from '../constants'

const ProfileSidebar = () => import('../components/Profile/ProfileSidebar.vue')

const AdvertisingBidSessions = () => import('../components/BidSessions/Advertising/BidSessions.vue')
const AdvertisingBidSessionDetailsModal = () => import('../components/BidSessions/Advertising/BidSessionDetailsModal.vue')
const DeleteAdvertisingBidSessionModal = () => import('../components/BidSessions/Advertising/DeleteAdvertisingBidSessionModal.vue')

const BiddingBidSessions = () => import('../components/BidSessions/Bidding/BidSessions.vue')
const BiddingBidSessionDetailsModal = () => import('../components/BidSessions/Bidding/BidSessionDetailsModal.vue')
const DeleteBiddingBidSessionModal = () => import('../components/BidSessions/Bidding/DeleteBiddingBidSessionModal.vue')

const BidsModalAuthenticator = () => import('../components/BidSessions/BidsModalAuthenticator.vue')

export const routes = () => [
  {
    path: '/munkaadoi-ajanlatok',
    components: {
      default: AdvertisingBidSessions,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    children: [
      {
        path: 'ajanlat/:id/elozmeny',
        component: BidsModalAuthenticator,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Offers - Advertiser - Bid History',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_ADVERTISER,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id/torles',
        component: DeleteAdvertisingBidSessionModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Offers - Advertiser - Delete',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_ADVERTISER,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id',
        component: AdvertisingBidSessionDetailsModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Offers - Advertiser - Details',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_ADVERTISER,
          wrapperClass: 'profile-wrapper'
        }
      }
    ],
    meta: {
      pageTitle: 'Offers - Advertiser',
      requiresAuth: true,
      requiresValidProfile: true,
      view: VIEW_ADVERTISER,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/munkaadoi-ajanlataim',
    components: {
      default: BiddingBidSessions,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    children: [
      {
        path: 'ajanlat/:id/elozmeny',
        component: BidsModalAuthenticator,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Offers - Employer - Bid History',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_EMPLOYER,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id/torles',
        component: DeleteBiddingBidSessionModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Offers - Employer - Delete',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_EMPLOYER,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id',
        component: BiddingBidSessionDetailsModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Offers - Employer - Details',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_EMPLOYER,
          wrapperClass: 'profile-wrapper'
        }
      }
    ],
    meta: {
      pageTitle: 'Offers - Employer',
      requiresAuth: true,
      requiresValidProfile: true,
      view: VIEW_EMPLOYER,
      wrapperClass: 'profile-wrapper'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/bid-sessions.js